// ================================================================================
// wp-block-accordion.js
// アコーディオンブロックのスクリプトファイル
// ================================================================================

document.addEventListener('DOMContentLoaded', () => {
	const DURATION = 300;
	const EASING = 'ease';

	const items = document.querySelectorAll('.wp-block-accordion-item');
	if (!items.length) return;

	const getIsOpen = (item, button) => {
		return button.getAttribute('aria-expanded') === 'true' || item.classList.contains('is-open');
	};

	const setPanelHeight = (panel, v) => {
		panel.style.display = 'block';
		panel.style.overflow = 'hidden';
		panel.style.height = v;
	};

	const animatePanel = async (panel, fromPx, toPx) => {
		if (panel._waapi) {
			try { panel._waapi.cancel(); } catch (e) {}
		}
		panel._waapi = panel.animate(
			{ height: [fromPx + 'px', toPx + 'px'] },
			{ duration: DURATION, easing: EASING }
		);
		try { await panel._waapi.finished; } catch (e) {}
		panel._waapi = null;
	};

	items.forEach((item) => {
		const button = item.querySelector('.wp-block-accordion-heading__toggle');
		const panel = item.querySelector('.wp-block-accordion-panel');
		if (!button || !panel) return;

		// 初期：閉は0、開はauto（CSSにheightを書かない前提）
		const initialOpen = getIsOpen(item, button);
		setPanelHeight(panel, initialOpen ? 'auto' : '0px');
		item.dataset.prevOpen = initialOpen ? '1' : '0';

		// ★重要：WPが状態を変える“前”に高さをinlineで固定（閉じる時のカクつき除去）
		button.addEventListener('click', () => {
			if (!getIsOpen(item, button)) return; // 開いてる時だけロック
			const h = panel.getBoundingClientRect().height;
			if (h > 0) setPanelHeight(panel, h + 'px');
		}, { capture: true });

		let isBusy = false;

		const sync = async () => {
			const nowOpen = getIsOpen(item, button);
			const prevOpen = item.dataset.prevOpen === '1';
			if (nowOpen === prevOpen) return;

			item.dataset.prevOpen = nowOpen ? '1' : '0';
			if (isBusy) return;
			isBusy = true;

			let fromPx = panel.getBoundingClientRect().height;

			if (nowOpen) {
				// 開く
				setPanelHeight(panel, 'auto');
				const toPx = panel.scrollHeight;

				setPanelHeight(panel, fromPx + 'px');
				panel.offsetHeight;

				await animatePanel(panel, fromPx, toPx);
				setPanelHeight(panel, 'auto');
			} else {
				// 閉じる：captureでロック済みの高さを起点に0へ
				fromPx = panel.getBoundingClientRect().height;

				setPanelHeight(panel, fromPx + 'px');
				panel.offsetHeight;

				await animatePanel(panel, fromPx, 0);
				setPanelHeight(panel, '0px');
			}

			isBusy = false;
		};

		const mo = new MutationObserver(() => { sync(); });
		mo.observe(button, { attributes: true, attributeFilter: ['aria-expanded'] });
		mo.observe(item, { attributes: true, attributeFilter: ['class'] });

		// タイミング差吸収
		button.addEventListener('click', () => {
			requestAnimationFrame(() => requestAnimationFrame(sync));
		}, { capture: true });
	});
});
